import EventEmitter from 'events';

import {DEVICE_RECONNECT} from '../../consts/app/eventTypes';

let instance = null;

export default class ReconnectEventEmitter extends EventEmitter {
    constructor(createNew) {
        if (createNew && instance) {
            instance.removeAllReconnectListeners();
            instance = null;
        }

        if (instance) {
            return instance;
        }

        super();
        instance = this;
    }

    emitReconnect(...args) {
        this.emit(DEVICE_RECONNECT, ...args);
    }

    onReconnect(func) {
        this.on(DEVICE_RECONNECT, func);
    }

    offReconnect(func) {
        this.off(DEVICE_RECONNECT, func);
    }

    removeAllReconnectListeners() {
        this.removeAllListeners(DEVICE_RECONNECT);
    }
}
